import { render, staticRenderFns } from "./layoutPop.vue?vue&type=template&id=3d4cfc4a&scoped=true"
import script from "./layoutPop.vue?vue&type=script&lang=js"
export * from "./layoutPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4cfc4a",
  null
  
)

export default component.exports